/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiRoamingFaqGet$Params {

/**
 * Application type. 1 - Web, 2 - Mobile.
 */
  appType?: number;

/**
 * Localization.
 */
  lang?: string;
}

export function apiRoamingFaqGet(http: HttpClient, rootUrl: string, params?: ApiRoamingFaqGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, apiRoamingFaqGet.PATH, 'get');
  if (params) {
    rb.query('appType', params.appType, {});
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

apiRoamingFaqGet.PATH = '/api/Roaming/faq';
